
interface Application {
  id: number;
  title: string;
  description: string;
  icon: string;
  features: string[];
}

export default function ApplicationsSection() {
  const applications: Application[] = [
    {
      id: 1,
      title: 'IoT & Communications',
      description: 'Satellite-enabled IoT connectivity and broadband communications for global reach',
      icon: 'ri-wireless-charging-line',
      features: ['Satellite Internet', 'Secure Communications', 'Global IoT Connectivity', 'Broadband Access']
    },
    {
      id: 2,
      title: 'Climate Monitoring',
      description: 'Advanced CO₂ tracking, weather monitoring, and disaster prediction systems',
      icon: 'ri-earth-line',
      features: ['CO₂ Tracking', 'Weather Forecasting', 'Disaster Prediction', 'Climate Analytics']
    },
    {
      id: 3,
      title: 'Earth Observation',
      description: 'Agriculture monitoring, urban development tracking, and geospatial mapping solutions',
      icon: 'ri-map-line',
      features: ['Agricultural Monitoring', 'Urban Planning', 'Geospatial Mapping', 'Resource Management']
    },
    {
      id: 4,
      title: 'Emergency Response',
      description: 'Disaster relief coordination, rapid communication, and real-time mapping for crisis management',
      icon: 'ri-emergency-line',
      features: ['Disaster Relief', 'Crisis Communication', 'Real-time Mapping', 'Emergency Coordination']
    },
    {
      id: 5,
      title: 'National Security',
      description: 'Advanced satellites, drones, and engines for defence and aerospace supremacy',
      icon: 'ri-shield-line',
      features: ['Defense Satellites', 'Surveillance Drones', 'Secure Communications', 'Aerospace Security']
    },
    {
      id: 6,
      title: 'Interplanetary Missions',
      description: 'Advanced propulsion and spacecraft systems for Mars, Moon, and deep space exploration',
      icon: 'ri-planet-line',
      features: ['Mars Missions', 'Lunar Exploration', 'Deep Space Probes', 'Interplanetary Travel']
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Core Applications
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Vyoamyug's aerospace technologies serve diverse applications from IoT connectivity 
            to national security, transforming how India approaches space-based solutions
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {applications.map((app) => (
            <div
              key={app.id}
              className="group bg-gray-800/50 rounded-2xl border border-gray-700 hover:border-blue-400/50 transition-all duration-500 hover:transform hover:scale-105 p-8 h-full flex flex-col"
            >
              <div className="text-center mb-6 flex-shrink-0">
                <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mx-auto mb-4 group-hover:scale-110 transition-transform duration-500 animate-pulse">
                  <i className={`${app.icon} text-3xl text-white group-hover:animate-spin`} style={{animationDuration: '3s'}}></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{app.title}</h3>
                <p className="text-gray-400 mb-6 leading-relaxed">{app.description}</p>
              </div>
              
              <div className="space-y-3 flex-grow">
                {app.features.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-3 group-hover:animate-fadeIn" style={{animationDelay: `${index * 0.1}s`}}>
                    <i className="ri-check-line text-blue-400 text-sm animate-bounce" style={{animationDelay: `${index * 0.2}s`}}></i>
                    <span className="text-gray-300 text-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
